<template>
  <a v-if="canShow()" :href="brandDetails.download.itune" target="_blank">
    <img
      src="@/assets/apple-store.svg"
      alt="appstore"
      class="track-click"
      :width="width"
      height="auto"
      @click="trackAnchorClick"
      :class="{ 'va-base': brandDetails.mobileAppQr }"
    />
  </a>
</template>
<script>
import brand from "@/helpers/brand";
import { isIOSDevice } from "@/helpers/userAgent";
import { trackDownloadNativeAppsButtonClick } from "@/telemetry/mailboxNudgeEvents";

export default {
  name: "AppleDownloadButton",
  data: () => {
    return {
      brandDetails: brand.getDetails(),
    };
  },
  props: {
    checkCompatibility: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 170,
    },
    /** Analytics: which surface hosts the button. */
    sourceHook: {
      type: String,
      default: "control_panel_tab",
    },
  },
  methods: {
    canShow() {
      if (!this.brandDetails.download.itune) return false;
      if (this.checkCompatibility) return isIOSDevice();
      return true;
    },
    trackAnchorClick() {
      // button_name was historically "play_store" here (swapped with the
      // Android button) — corrected to "app_store" per the nudge spec.
      trackDownloadNativeAppsButtonClick({
        buttonName: "app_store",
        sourceHook: this.sourceHook,
        viewSection: "desktop_and_mobile",
      });
    },
  },
};
</script>
